import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const DistribuionCountAPI = createAsyncThunk("DistribuionCount", async ({ data }) => {
    const {
        M_WardID,
        M_FinancialYearID,
        M_MonthID,
        token,
        M_UserID,
        Flag,
        handleGetCount,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_Distri_MainCount_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID ? M_MonthID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_MainLine_MainCount_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID ? M_MonthID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}`
    }
    return fetch(url, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {
                handleGetCount(result.data.table)
                return result.data
            } else {
                return result
            }
        })
        .then(result => {
            if (result && result.code >= 200 && result.code <= 300 && result.data) {
                let tempData = {}
                result.data.forEach((item) => {
                    tempData[item.paramName] = item.totalCount
                })
                return result.data
            } else {
                return result
            }
        })
})

const DistribuionCountSlice = createSlice({
    name: "DistribuionCount",
    initialState: {
        isLoading: false,
        CountData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DistribuionCountAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DistribuionCountAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.CountData = action.payload;
        });
        builder.addCase(DistribuionCountAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.CountData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const DistribuionCountReducer = DistribuionCountSlice.reducer

export const WTPDashboardCountAPI = createAsyncThunk("WTPDashboardCount", async ({ data }) => {
    const {
        M_WardID,
        M_FinancialYearID,
        M_MonthID,
        token,
        M_UserID,
        Flag,
        handleGetCount,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };


    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_WS_WTP_MainCount_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_WardID=${M_WardID}&M_UserID=${M_UserID}&Flag=${Flag}`, requestOptions)

        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {
                handleGetCount(result.data.table)
                return result.data
            } else {
                return result
            }
        })
        .then(result => {
            if (result && result.code >= 200 && result.code <= 300 && result.data) {
                let tempData = {}
                result.data.forEach((item) => {
                    tempData[item.paramName] = item.totalCount
                })
                return result.data
            } else {
                return result
            }
        })
})

const WTPDashboardCountSlice = createSlice({
    name: "WTPDashboardCount",
    initialState: {
        isWTPLoading: false,
        WTPCountData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPDashboardCountAPI.pending, (state, action) => {
            state.isWTPLoading = true;
        });
        builder.addCase(WTPDashboardCountAPI.fulfilled, (state, action) => {
            state.isWTPLoading = false;
            state.WTPCountData = action.payload;
        });
        builder.addCase(WTPDashboardCountAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isWTPLoading = false;
            state.isError = true;
            state.WTPCountData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPDashboardCountReducer = WTPDashboardCountSlice.reducer